/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React from "react";
import { styled } from "theme/default/styled";

export const SFormLayoutLogo = styled.div<{ finOnWidth?: string } & React.ButtonHTMLAttributes<HTMLButtonElement>>`
  width: ${(props) => props.finOnWidth || "250px"};
  height: 80px;
  margin-top: ${(props) => (props.finOnWidth ? "25vh" : "100px")};
`;
